import { useEffect, useRef } from 'react';
import { DuelsPlayerStepName } from './duels-player-step-name';
import { DuelsPlayerStepQuestion } from './duels-player-step-question';
import { DuelsPlayerStepResult } from './duels-player-step-result';
import { DuelsPlayerCountdown } from './duels-player-countdown';
import { useWeeklyChallenge } from '@/hooks/useWeeklyChallenge';
import { Sheet, SheetContent, SheetTitle } from '@/components/ui/sheet';
import { ChallengeModal } from '@/components/custom/challenge';

export function DuelsPlayer({ duel, setOpenPlayerModal, setNewDuelModal, openPlayerModal, winner, getWinner, setWinner, onCloseRefresh }) {
  const questionCountdownRef = useRef();

  const { setCurrentStep, setStart, currentStep, setShowQuestionCountDown, showQuestionCountDown, taxonomies, setQuestionCountDownTimer, setGeneralCount, setChallengeType } = useWeeklyChallenge();

  const handleCloseModal = () => {
    setGeneralCount(0);
    setOpenPlayerModal(false);
    setStart(false);
    setShowQuestionCountDown(false);
    setQuestionCountDownTimer(5);
    setWinner(null);
    onCloseRefresh?.();
    setChallengeType(null);
  };

  useEffect(() => {
    if (openPlayerModal && currentStep === 1) {
      questionCountdownRef.current = setTimeout(() => {
        setShowQuestionCountDown(true);
      }, 6000);
    }
    return () => {
      if (questionCountdownRef.current) {
        clearTimeout(questionCountdownRef.current);
      }
    };
  }, [openPlayerModal, taxonomies]);

  return (
    <Sheet
      open={openPlayerModal}
      onOpenChange={newOpenState => {
        setNewDuelModal(newOpenState);
        // Só execute a função se o modal estiver fechando
        if (!newOpenState) {
          handleCloseModal();
        }
      }}
    >
      <SheetContent
        size="lg"
        hideCloseButton
      >
        <SheetTitle className="sr-only">Defafio</SheetTitle>

        <ChallengeModal>
          {currentStep === 1 && <DuelsPlayerStepName duel={duel} />}
          {currentStep === 2 && <DuelsPlayerStepQuestion />}
          {currentStep === 3 && (
            <DuelsPlayerStepResult
              setNewDuelModal={setNewDuelModal}
              winner={winner}
              getWinner={getWinner}
              handleCloseModal={handleCloseModal}
            />
          )}
        </ChallengeModal>

        <DuelsPlayerCountdown
          showQuestionCountDown={showQuestionCountDown}
          setShowQuestionCountDown={setShowQuestionCountDown}
        />
      </SheetContent>
    </Sheet>
  );
}
